import '../rightbar/rightbar.scss';
import { useRightbar } from './hooks/useRightbar';
import { SuggestionList } from './components/SuggestionList';
import { ActivityList } from './components/ActivityList';
import { OnlineFriendList } from './components/OnlineFriendList';

const Rightbar = () => {
  const { 
    suggestionsLoading, 
    suggestions, 
    isAddingFriend, 
    onAddFriend, 
    onDeleteSuggestion, 
    activities, 
    onlineFriends 
  } = useRightbar();

  return (
    <div className='rightbar'>
      <div className="container">   
        <SuggestionList 
          isLoading={suggestionsLoading}
          suggestions={suggestions}
          isAddingFriend={isAddingFriend}
          onAddFriend={onAddFriend}
          onDeleteSuggestion={onDeleteSuggestion}
        />

        <ActivityList activities={activities} />

        <OnlineFriendList onlineFriends={onlineFriends} />

      </div>
    </div>
  );
};

export default Rightbar;